import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';
import * as moment from 'moment';
import { convertToUtcDates } from 'src/app/services/utility.service';

@Component({
  selector: 'app-update-last-inventoried-date-dialog',
  templateUrl: './update-last-inventoried-date-dialog.component.html',
  styleUrls: ['./update-last-inventoried-date-dialog.component.scss']
})
export class UpdateLastInventoriedDateDialogComponent {
  public form: FormGroup;
  public faTimes = faTimes;
  public faSave = faSave;

  constructor(
    private dialogRef: MatDialogRef<UpdateLastInventoriedDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { itemCount: number },
    private fb: FormBuilder
  ) {
    // Format the current date in a format that works with datetime-local input
    const now = moment();
    this.form = this.fb.group({
      lastInventoriedDate: [now.format('YYYY-MM-DDTHH:mm')]
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    if (this.form.valid) {
      const formValue = convertToUtcDates(this.form.value, ['lastInventoriedDate']);
      this.dialogRef.close(formValue.lastInventoriedDate);
    }
  }
} 